// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__3lTeP","l3":"loader_l3__gj9Zr"};